import { Theme } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-pro';

const editRowStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#545344 !important' : '#ffd3a3 !important',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? '#545344 !important' : '#ffc88c !important',
  },
})

export const getRecoTableStyles = (theme: Theme) => ({
  border: 0,
  boxShadow: 2,
  borderRadius: 0,
  '& .MuiDataGrid-scrollbar--horizontal' : {
    bottom : 'unset'
  },
  '& .MuiSelect-select' : {
    minHeight: 'unset',
    backgroundColor: 'inherit',
  },
  '& .MuiIconButton-root' : {
    color: theme.palette.text.primary,
  },
  '& .MuiSelect-icon' : {
    color: theme.palette.text.primary,
  },
  [`& .${gridClasses.cell}`] : {
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  },
  [`& .${gridClasses.row}:hover .${gridClasses.cell}`]: {
    backgroundColor: theme.palette.background.default,
  },
  [`& .${gridClasses.row}.Mui-selected .${gridClasses.cell}`]: {
    backgroundColor: theme.palette.background.default,
  },
  [`& .${gridClasses.row}.Mui-selected:hover .${gridClasses.cell}`]: {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-columnSeparator' : {
    color: theme.palette.divider,
  },
  [`& .${gridClasses.columnHeader}`] : {
    borderColor: theme.palette.divider,
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
  },
  [`.${gridClasses['columnHeader--filter']}`]: { 
    px: 1 
  },
  // Disabled row styling
  [`& .${gridClasses.row}.row--disabled`]: {
    backgroundColor: theme.palette.action.disabledBackground + ' !important',
    color: theme.palette.action.disabled + ' !important',
    '&:hover': {
      backgroundColor: theme.palette.action.disabledBackground + ' !important',
    },
  },
  [`& .${gridClasses.row}.row--disabled .MuiDataGrid-cell`]: {
    color: theme.palette.action.disabled,
    backgroundColor: theme.palette.action.disabledBackground + ' !important',
  },

  [`& .${gridClasses.row}.row--edited`]: {
    ...editRowStyle(theme),
  },
  [`& .${gridClasses.row}.row--edited .MuiDataGrid-cell`]: {
    ...editRowStyle(theme),
  },
  [`& .${gridClasses.row}.row--edited .MuiDataGrid-cell--pinnedLeft`]: {
    ...editRowStyle(theme),
  },
  [`& .${gridClasses.row}.row--edited .MuiDataGrid-cell--pinnedRight`]: {
    ...editRowStyle(theme),
  },

  // Cell modification styling (Green)
  [`& .${gridClasses.cell}.cell--edited`]: {
    backgroundColor: '#d4ebd3 !important',
    '&:hover': {
      backgroundColor: '#b8dbb8 !important',
    },
  }
});
